module.exports = __webpack_public_path__ + "static/media/0021_IMG_LES_ENSEIGNES_LES_PAINS_SCRABBLE.b3e45c12.webp";